import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import {
  fetchJsonRawReponse,
  fetchJsonData,
  postJsonRawResponse,
} from '../../../../global/data/service'
import { getLocalPath } from '../../../../spa/utility/config/configuration'
import { generateUID } from '../../../utility/threatMetrix/TMX.js'
import { isLocal } from '../../../../global/environments'
import DOMPurify from 'dompurify'
export * from './institutionalConstants.js'
export * from './institutionalConfig.js'
import { showAlertBanner } from '../../../../components/AlertBanner/index.js'
import {
  STATUS_ERROR,
  STATUS_SUCCESS,
} from '../../../../components/AlertBanner/Constants.js'
import { getApiTokenUrl } from '../../../../global/environments/config'
import { apiEndPoint, REPORT_ORDER } from './institutionalConstants.js'
import {
  getClientId,
  getClientSecret,
  accessStorage,
} from './institutionalConfig.js'

let mockDataApi = {}
const isLocalDebug = isLocal()
async function mockTestData() {
  if (isLocalDebug) {
    const { mockData } = await import('./mockData.js')
    mockDataApi = mockData
  }
}
mockTestData()

export async function getBREDocumentData(scope) {
  try {
    const url = `${getLocalPath()}/halapi/documents?_scope=/content/documents/cti-institutional/${scope}`
    const data = await fetchJsonData(url)
    return data?._embedded?.documents ?? []
  } catch (error) {
    showAlertError(error)
  }
}

export const reportOrderIndex = new Map(REPORT_ORDER.map((v, i) => [v, i]))

export const showAlertError = (text) => {
  showAlertBanner({
    status: STATUS_ERROR,
    title: 'Error',
    text,
  })
}

export const showAlertSuccess = (payload) => {
  const { title, text, sticky = true } = payload
  showAlertBanner({
    status: STATUS_SUCCESS,
    title,
    text,
    sticky,
  })
}

function getHeaders(otherHeaders) {
  const headers = {
    ...accessStorage.getTracingIds(),
    apitoken: accessStorage.getToken(),
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    ...otherHeaders,
  }
  return headers
}

function updateApiToken(responseData) {
  const apitoken = responseData?.headers?.get('apitoken')
  if (apitoken != null || apitoken != undefined) {
    accessStorage.setToken(apitoken)
  }
}

export async function fetchToken(tmxId) {
  const tmx_id = tmxId ? tmxId : `cti_ins_${generateUID()}`
  const websession_id = `web_session_${generateUID()}`
  const wamCorrelationId = generateUID()
  const appCorrelationid = generateUID()
  const headers = getHeaders({
    clientId: getClientId(),
    clientSecret: getClientSecret(),
  })
  //delete headers['x-correlation-id']
  const url = getApiTokenUrl()
  const tokenResponseData = isLocalDebug
    ? await mockDataApi?.getApiToken(url, headers)
    : await fetchJsonRawReponse(url, headers)
  updateApiToken(tokenResponseData)
  //const correlationId = tokenResponseData.headers.get('x-correlation-id')
  accessStorage.setTracingIds({
    wam_corelation_id: wamCorrelationId,
    app_corelation_id: appCorrelationid,
    tmx_id,
    websession_id,
  })
}

export async function makeLoginRequest(data, otherHeaders = null) {
  const headers = getHeaders(otherHeaders)
  const responseData = isLocalDebug
    ? await mockDataApi?.getLoginMockData(apiEndPoint.login, data, headers)
    : await postJsonRawResponse(apiEndPoint.login, data, headers)
  updateApiToken(responseData)
  return responseData.json()
}

export async function makeMFARequest(data, otherHeaders = null) {
  const headers = getHeaders(otherHeaders)
  const responseData = isLocalDebug
    ? await mockDataApi?.getMFAMockData(apiEndPoint.mfa, data, headers)
    : await postJsonRawResponse(apiEndPoint.mfa, data, headers)
  updateApiToken(responseData)
  return responseData.json()
}

export async function makeMFAnswerRequest(data, otherHeaders = null) {
  const headers = getHeaders(otherHeaders)
  const responseData = isLocalDebug
    ? await mockDataApi?.getMFAnswerMockData(
        apiEndPoint.mfanswer,
        data,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.mfanswer, data, headers)
  updateApiToken(responseData)
  return responseData.json()
}

export async function makeForgotPasswordRequest(data, otherHeaders = null) {
  const headers = getHeaders(otherHeaders)
  const bodyData = { ...data, userType: 'INST_CLT' }
  const responseData = isLocalDebug
    ? await mockDataApi?.getForgotPasswordMockData(
        apiEndPoint.forgotPassword,
        bodyData,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.forgotPassword, bodyData, headers)
  updateApiToken(responseData)
  return responseData.json()
}

export async function makeRiskAdviseRequest(data, otherHeaders = null) {
  const headers = getHeaders(otherHeaders)
  const responseData = isLocalDebug
    ? await mockDataApi?.getRiskAdviceMockData(
        apiEndPoint.riskAdvice,
        data,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.riskAdvice, data, headers)
  updateApiToken(responseData)
  return responseData.json()
}

export async function makeChangePasswordRequest(data, otherHeaders = null) {
  const headers = getHeaders({ ...otherHeaders })
  const responseData = isLocalDebug
    ? await mockDataApi?.getChangePasswordMockData(
        apiEndPoint.changePassword,
        data,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.changePassword, data, headers)
  updateApiToken(responseData)
  return responseData.json()
}

export async function getUserInfo(data, otherHeaders = null) {
  const headers = getHeaders({ ...otherHeaders })
  const responseData = isLocalDebug
    ? await mockDataApi?.getUserInfoMockData(apiEndPoint.getUser, data, headers)
    : await postJsonRawResponse(apiEndPoint.getUser, data, headers)
  return responseData.json()
}

export async function getUserInfoPreference(data, otherHeaders = null) {
  const headers = getHeaders({ ...otherHeaders })
  const responseData = isLocalDebug
    ? await mockDataApi?.getUserInfoPreferenceMockData(
        apiEndPoint.userPreference,
        data,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.userPreference, data, headers)
  return responseData.json()
}

export async function downloadAccountReport(data, otherHeaders = null) {
  const headers = getHeaders({ ...otherHeaders })
  const responseData = isLocalDebug
    ? await mockDataApi?.downloadAccountReportMockData(
        apiEndPoint.downloadReport,
        data,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.downloadReport, data, headers)
  return responseData.json()
}

export async function getAccountReport(data, otherHeaders = null) {
  const headers = getHeaders({ ...otherHeaders })
  const responseData = isLocalDebug
    ? await mockDataApi?.getAccountReportMockData(
        apiEndPoint.getAccountReport,
        data,
        headers
      )
    : await postJsonRawResponse(apiEndPoint.getAccountReport, data, headers)
  return responseData.json()
}

const getMimetype = (reportType) => {
  const mimeTypes = {
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    pdf: 'application/pdf',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }
  return mimeTypes[reportType] || 'application/octet-stream'
}

const startDownloadFile = (reportFileName, blob) => {
  const link = document.createElement('a')
  const objectUrl = URL?.createObjectURL(blob)
  // Guard: URL.createObjectURL always produces a blob: URL; validate before use
  if (objectUrl && /^blob:/.test(objectUrl)) {
    link.href = objectUrl
    link.download = DOMPurify.sanitize(reportFileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
  }
}

const getDownloadBlob = async (data) => {
  const output = {}
  try {
    const responseData = await downloadAccountReport(data)
    const { reportContent, reportFileName, reportType } = responseData.value
    const byteCharacters = atob(reportContent)
    const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
    const byteArray = new Uint8Array(byteNumbers)
    output.fileName = reportFileName
    //create a blob object
    const blobData = new Blob([byteArray], { type: getMimetype(reportType) })
    output.blobData = blobData
    return output
  } catch (error) {
    showAlertError('Unable to process your request Please try later.')
    return null
  }
}

export const downloadFiles = async (
  payload,
  bodyData,
  ShowLoader = () => {}
) => {
  ShowLoader(true)
  if (Array.isArray(payload)) {
    const zip = new JSZip()
    for (const report of payload) {
      const response = await getDownloadBlob({
        ...bodyData,
        reportId: report?.reportId,
      })
      zip.file(report?.reportFileName, response?.blobData)
    }
    zip.generateAsync({ type: 'blob' }).then((zipFile) => {
      saveAs(zipFile, 'Package.zip')
    })
  } else {
    const response = await getDownloadBlob({ ...bodyData, reportId: payload })
    startDownloadFile(response?.fileName, response?.blobData)
  }
  ShowLoader(false)
}

export const contactRM = (rmDetails) => {
  if (rmDetails) {
    const data = {
      name: rmDetails?.rmName,
      email: rmDetails?.emailAddress,
      phone: rmDetails?.phoneNumber,
    }
    accessStorage.setRMInfo(data)
  }
}
